RA.ResultsPage = {
  RAKEFederatedResults: true,
  init() {
    this.setVariables();
    this.initTabs();
    this.bindEvents();

    if (!Config.isCommunityEnabled) {
      this.$commSummary.hide();
      this.$commResultsPane.hide();
    }

    if (this.RAKEFederatedResults) {
      this.$rakeNonFederatedSummary.hide();
      this.$rakeNonFederatedResultPane.hide();
    }
  },
  setVariables() {
    this.$resultTabsList = $("#resultTabsList");
    this.isAddAllTab = "auto";
    this.validSearchMethods = ["neural", "hybrid", "keyword", "hide"];

    let searchMethodAvailableList = Config.searchMethodAvailable.toLowerCase().split(",")
      .map(method => method.trim())
      .filter(method => method.length > 0 && this.validSearchMethods.includes(method));

    const validDefaultSearchMethod = this.validSearchMethods.includes(Config.searchMethodDefault.toLowerCase()) ? Config.searchMethodDefault.toLowerCase() : "keyword";

    if (!searchMethodAvailableList.includes(validDefaultSearchMethod)) {
      searchMethodAvailableList.push(validDefaultSearchMethod);
    }

    searchMethodAvailableList = searchMethodAvailableList.map(method => {
      return {
        key: method,
        label: method.charAt(0).toUpperCase() + method.slice(1)
      }
    })

    this.kbFilterData = {
      sortKeys: [
        { key: 'relevance', label: Labels.getLabel('Relevance') },
        { key: 'viewcount', label: Labels.getLabel('Most Views') },
        { key: 'solvedcount', label: Labels.getLabel('Most Helpful') },
        { key: 'problem_as_keyword', label: Labels.getLabel('Title Z-A') },
        { key: 'problem_as_keyword', descending: false, label: Labels.getLabel('Title A-Z') },
        { key: 'last_modified_date', label: Labels.getLabel('Newest on Top') },
        { key: 'last_modified_date', descending: false, label: Labels.getLabel('Oldest on Top') }
      ],
      searchCriteriaKeys: searchMethodAvailableList
    };

    this.rakeNonFederatedFilterData = {
      sortKeys: [
        { key: 'relevance', label: Labels.getLabel('Relevance') },
        { key: 'viewcount', label: Labels.getLabel('Most Views') },
        { key: 'solvedcount', label: Labels.getLabel('Most Helpful') },
        { key: 'problem_as_keyword', label: Labels.getLabel('Title Z-A') },
        { key: 'problem_as_keyword', descending: false, label: Labels.getLabel('Title A-Z') },
        { key: 'last_modified_date', label: Labels.getLabel('Newest on Top') },
        { key: 'last_modified_date', descending: false, label: Labels.getLabel('Oldest on Top') }
      ],
      searchCriteriaKeys: searchMethodAvailableList
    };

    this.commFilterData = {
      sortKeys: [
        { key: "relevance", label: Labels.getLabel("Relevance") },
        { key: "viewcount", label: Labels.getLabel("Most Views") },
        { key: "last_modified_date", label: Labels.getLabel("Newest on Top") },
        { key: "last_modified_date", descending: false, label: Labels.getLabel("Oldest on Top") }
      ]
    };

    this.otherSearchCallbacks = [];

    this.$kbSummary = $("#kbSummary");
    this.$commSummary = $("#commSummary");
    this.$kbResultsPane = $("#kbResults");
    this.$commResultsPane = $("#commResults");

    let kbParams = ["querytext", "kbsort", "kbdesc", "attributesetname", "attributes", "searchaliases", "advkeywords", "taxonomypath", "kbd0", "kbd1", "language", "kbpage", "favoritesOnly", "searchCriteria"];
    this.kbQueryString = Object.create(RA.QueryStringMapper);
    this.kbQueryString.init(kbParams);
    this.kbQueryString.addRenameMapping("kbpage", "currentpage");
    this.kbQueryString.addRenameMapping("taxonomypath", "taxlevelValue");
    this.kbQueryString.addRenameMapping("kbsort", "sortBy");
    this.kbQueryString.addRenameMapping("kbdesc", "descending");
    this.kbQueryString.addRenameMapping("kbd0", "advstartdate");
    this.kbQueryString.addRenameMapping("kbd1", "advenddate");

    let commParams = ["querytext", "commsort", "commdesc", "answered", "communityID", "topicID", "tags", "commd0", "commd1", "commpage"];
    this.commQueryString = Object.create(RA.QueryStringMapper);
    this.commQueryString.init(commParams);
    this.commQueryString.addRenameMapping("commpage", "currentpage");
    this.commQueryString.addRenameMapping("commsort", "sortBy");
    this.commQueryString.addRenameMapping("commdesc", "descending");
    this.commQueryString.addRenameMapping("commd0", "beginLastModDate");
    this.commQueryString.addRenameMapping("commd1", "endLastModDate");

    let rakeNonFederatedParams = ["querytext", "rakenonfederatedsort", "rakenonfederateddesc", "attributesetname", "attributes", "searchaliases", "taxlevelValue", "language", "rakenonfederatedpage", "favoritesOnly", "searchCriteria"];
    this.rakeNonFederatedQueryString = Object.create(RA.QueryStringMapper);
    this.rakeNonFederatedQueryString.init(rakeNonFederatedParams);
    this.rakeNonFederatedQueryString.addRenameMapping("rakenonfederatedpage", "currentpage");
    this.rakeNonFederatedQueryString.addRenameMapping("rakenonfederatedsort", "sortBy");
    this.rakeNonFederatedQueryString.addRenameMapping("rakenonfederateddesc", "descending");
  },
  bindEvents() {
    $(window).on("popstate", this.onPopState.bind(this));
    this.$resultTabsList.on("click", "a", this.tabClicked.bind(this));
  },
  initSearch() {
    let kbQuery = this.kbQueryString.getValues();
    let commQuery = this.commQueryString.getValues();
    let rakeNonFederatedQuery = this.rakeNonFederatedQueryString.getValues();

    this.loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery);
    this.showTab();
  },
  loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery, extraParams) {
    RA.showOverlay(this.$kbSummary);
    RA.showOverlay(this.$kbResultsPane);

    RA.KBSearch.search(kbQuery, searchResults => {
      this.showKBSummary(searchResults);
      this.showKBResults(searchResults);
      localStorage.removeItem('pauseSolutionAutoView');

      RA.hideOverlay(this.$kbSummary);
      RA.hideOverlay(this.$kbResultsPane);
    }, extraParams);

    if (!this.RAKEFederatedResults) {
      RA.showOverlay(this.$rakeNonFederatedSummary);
      RA.showOverlay(this.$rakeNonFederatedResultPane);

      RA.RakeNonFederatedSearch.search(rakeNonFederatedQuery, searchResults => {
        this.showRakeNonFederatedSummary(searchResults);
        this.showRakeNonFederatedResults(searchResults);

        RA.hideOverlay(this.$rakeNonFederatedSummary);
        RA.hideOverlay(this.$rakeNonFederatedResultPane);
      }, { searchCriteria: 'keyword' });

    }

    if (Config.isCommunityEnabled) {
      RA.showOverlay(this.$commSummary);
      RA.showOverlay(this.$commResultsPane);

      RA.CommunitySearch.search(commQuery, searchResults => {
        this.showCommSummary(searchResults);
        this.showCommResults(searchResults);

        RA.hideOverlay(this.$commSummary);
        RA.hideOverlay(this.$commResultsPane);
        this.updateCommunityContext(searchResults);
      }, extraParams);
    }
  },
  updateCommunityContext(searchResults) {
    let communityContext = {};
    let { communityID, topicID } = RA.CommunitySearch.query;
    if (communityID && searchResults.communities.length == 1) {
      let community = searchResults.communities[0];
      communityContext.community = { id: community.id, name: community.name };
    }

    if (topicID && searchResults.topics.length == 1) {
      let topic = searchResults.topics[0];
      communityContext.topic = { id: topic.id, name: topic.name };
    }

    RA.setCommunityContext(communityContext);
  },
  queryTextUpdating() {

  },

  /** Handles "instant search" */
  queryTextUpdated(e) {
    let queryText = e.value;

    let kbQuery = $.extend({}, RA.KBSearch.query, { querytext: queryText });
    let commQuery = $.extend({}, RA.CommunitySearch.query, { querytext: queryText });
    let rakeNonFederatedQuery = $.extend({}, RA.RakeNonFederatedSearch.query, { querytext: queryText });
    delete kbQuery.currentpage;
    delete commQuery.currentpage;
    delete rakeNonFederatedQuery.currentpage;

    // Do not want to log instant search for simple keypress event
    // Still want to log other events: submit (ENTER or click search) and autocomplete select
    let extraParams = {};
    if (e.type === "keypress") {
      extraParams.doSearchLogging = false;
    }

    this.loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery, extraParams);

    if (e.source == "kb") {
      this.showTab("#kbResults");
    } else if (e.source == "community") {
      this.showTab("#commResults");
    }

    if (history.pushState) {
      let paramMap = RA.Utils.getQueryParams();
      paramMap.querytext = queryText;
      delete paramMap.kbpage;
      delete paramMap.commpage;

      history.pushState({}, "", RA.Utils.buildQueryString(paramMap) + location.hash);
    }

    if (this.otherSearchCallbacks.length) {
      this.otherSearchCallbacks.forEach(callback => callback(queryText));
    }
  },
  initTabs() {
    this.resultTabs = [];
    this.$resultTabsList.empty();

    this.addTab({
      target: "#kbResults",
      label: Labels.getLabel("Knowledgebase"),
      className: "-kb"
    });

    if (Config.isCommunityEnabled) {
      this.addTab({
        target: "#commResults",
        label: Labels.getLabel("Community"),
        className: "-comm"
      });
    }

    let $tabContent = $("#allResults").closest(".tab-content");
    let $summaryRow = $("#allResults").find(".result-summary-wrap");

    $summaryRow.append("<section id='rakeNonFederatedSummary' class='result-summary' />");
    $tabContent.append("<div id='rakeNonFederatedResults' class='tab-pane' />");

    this.$rakeNonFederatedSummary = $("#rakeNonFederatedSummary");
    this.$rakeNonFederatedResultPane = $("#rakeNonFederatedResults");

    if (!this.RAKEFederatedResults) {
      this.addTab({
        target: "#rakeNonFederatedResults",
        label: Labels.getLabel("Knowledgebase External Sources")
      });
    }
  },
  addTab(tab) {
    this.resultTabs.push(tab);

    if (this.resultTabs.length == 1) {
      return;
    } else if (this.resultTabs.length == 2) {
      if (this.isAddAllTab !== false) {
        this.$resultTabsList.append(createTab({
          target: "#allResults",
          label: Labels.getLabel("All")
        }));
      }
      this.$resultTabsList.append(createTab(this.resultTabs[0]));
    }

    this.$resultTabsList.append(createTab(tab));

    function createTab(t) {
      let $li = $("<li>");
      $li.addClass("tab-bar__item")
        .attr("role", "tab");

      let $link = $("<a>");
      $link.addClass("tab-bar__link")
        .attr("href", t.target)
        .text(t.label)

      if (t.className) {
        $link.addClass(t.className);
      }

      return $li.append($link);
    }
  },
  tabClicked(e) {
    e.preventDefault();

    let $link = $(e.target);
    let href = $link.attr("href");

    this.showTab(href);

    $link.blur();
  },
  showTab(selector, updateState = true) {

    if (selector && selector.length) {
      let $link = this.$resultTabsList.find("a[href='" + selector + "']");
      $link.closest("ul")
        .find("li.active")
        .removeClass("active");

      $link.closest("li")
        .addClass("active");

      $(selector).closest(".tab-content")
        .find("> .active")
        .removeClass("active")
        .attr("aria-hidden", true);

      $(selector).addClass("active")
        .attr("aria-hidden", false);

      if (updateState && history.pushState) {
        history.pushState({}, "", `#t=${selector.substring(1)}`);
      }
    } else {
      let tabShown = false;
      let tabID = RA.Utils.buildParamMap(location.hash).t;

      if (tabID && tabID.length) {
        let target = "#" + tabID;
        let isValidTarget = (this.resultTabs.length > 1 && target == "#allResults") || this.resultTabs.some(t => t.target == target);

        if (isValidTarget) {
          this.showTab("#" + tabID, false);
          tabShown = true;
        }
      }

      if (!tabShown) {
        let defaultResultTab = "#" + Config.defaultResultTab.toLowerCase();
        let target = "";

        for (let i = 0; i < this.resultTabs.length; i++) {
          let tab = this.resultTabs[i];
          if (tab.target.toLowerCase() === defaultResultTab) {
            target = tab.target;
            const baseValue = this.resultTabs.length - 5;
            let initialSlide = 0;
            if(baseValue >= 0){
              initialSlide = Math.min(baseValue, i) + 1;
              if(initialSlide % 2 != 0){
                initialSlide = initialSlide - 1;
              }
            }
            sessionStorage.setItem("initialSlide", initialSlide);
            break;
          }
        }

        if (!target) {
          target = this.resultTabs.length > 1 && this.isAddAllTab !== false ? "#allResults" : this.resultTabs[0].target;
        }
        this.showTab(target, false);
      }
    }
  },
  onPopState(e) {
    let kbQuery = this.kbQueryString.getValues();
    let commQuery = this.commQueryString.getValues();
    let rakeNonFederatedQuery = this.rakeNonFederatedQueryString.getValues();


    let doKBSearch = !RA.Utils.compareObjects(RA.KBSearch.query, kbQuery);
    let doCommSearch = !RA.Utils.compareObjects(RA.CommunitySearch.query, commQuery);
    let doRakeNonFederatedSearch = !RA.Utils.compareObjects(RA.RakeNonFederatedSearch.query, rakeNonFederatedQuery);

    RA.SearchBar.setSearchText(kbQuery.querytext);

    if (kbQuery.querytext != RA.KBSearch.query.querytext) {
      this.loadSummaryAndResults(kbQuery, commQuery, rakeNonFederatedQuery);
    } else {
      if (doKBSearch) {
        RA.KBSearch.search(kbQuery, this.showKBResults.bind(this));
      }

      if (doCommSearch) {
        RA.CommunitySearch.search(commQuery, this.showCommResults.bind(this));
      }

      if (doRakeNonFederatedSearch) {
        RA.RakeNonFederatedSearch.search(rakeNonFederatedQuery, this.showRakeNonFederatedResults.bind(this), { searchCriteria: 'keyword' });
      }
    }

    this.showTab();
  },
  scrollToTopOfResults() {
    let topOffset = this.$resultTabsList.length ?
      this.$resultTabsList.offset().top - 15 : 0;

    if (window.scrollY > topOffset) {
      window.scrollTo(0, topOffset);
    }
  },

  showRakeNonFederatedSummary(searchResults) {
    ReactDOM.render(
      <RakeNonFederatedSummary
        searchResults={searchResults}
        eventHandler={this.handleRakeNonFederatedResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("rakeNonFederatedSummary")
    );
  },

  showRakeNonFederatedResults(searchResults) {
    ReactDOM.render(
      <RakeNonFederatedResults
        searchResults={searchResults}
        showCollectionFilter={RA.RakeNonFederatedSearch.getShowCollectionFilter()}
        showAttributeFilter={RA.RakeNonFederatedSearch.getShowAttributeFilter()}
        showFavoriteFilter={RA.RakeNonFederatedSearch.getShowFavoriteFilter()}
        filterData={this.rakeNonFederatedFilterData}
        eventHandler={this.handleRakeNonFederatedResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("rakeNonFederatedResults")
    );
  },

  showKBSummary(searchResults) {
    ReactDOM.render(
      <KBSummary
        searchResults={searchResults}
        eventHandler={this.handleKBResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("kbSummary")
    );
  },
  showKBResults(searchResults) {
    ReactDOM.render(
      <KBResults
        searchResults={searchResults}
        showCollectionFilter={RA.KBSearch.getShowCollectionFilter()}
        showAttributeFilter={RA.KBSearch.getShowAttributeFilter()}
        showFavoriteFilter={RA.KBSearch.getShowFavoriteFilter()}
        filterData={this.kbFilterData}
        eventHandler={this.handleKBResultsEvent.bind(this)}
        onEmailClicked={this.emailClicked.bind(this)}
        onPreviewClicked={this.previewClicked.bind(this)} />,
      document.getElementById("kbResults")
    );
  },
  emailClicked(hit, e) {
    let addData = {
      solutionID: hit.solution.id,
      solutionTitle: hit.solution.title,
      type: "regular",
      SToken: Config.csrf.value
    };

    RAEmail.init(addData, true);
  },
  previewClicked(hit, e) {

    e.preventDefault();

    // Configure preview solution for this result
    ExtQuickLinks.resultInfo = {
      id: hit.solution.id,
      title: hit.solution.title
    };

    ExtQuickLinks.previewResult(e);
  },
  showCommSummary(searchResults) {
    ReactDOM.render(
      <CommSummary
        searchResults={searchResults}
        eventHandler={this.handleCommResultsEvent.bind(this)} />,
      document.getElementById("commSummary")
    );
  },
  showCommResults(searchResults) {
    ReactDOM.render(
      <CommResults
        searchResults={searchResults}
        filterData={this.commFilterData}
        eventHandler={this.handleCommResultsEvent.bind(this)} />,
      document.getElementById("commResults")
    );
  },
  handleKBResultsEvent(event) {
    let callback = this.kbSearchComplete.bind(this);

    RA.showOverlay(this.$kbResultsPane);
    this.scrollToTopOfResults();

    switch (event.actionType) {
      case 'pageClicked':
        RA.KBSearch.loadPage(event.num, callback);
        break;
      case 'sortChanged':
        let { sortKey } = event;
        let descending = sortKey.descending == undefined ? "" : sortKey.descending;

        RA.KBSearch.applyFilter({ sortBy: sortKey.key, descending: descending, sortChanged: true },
          callback);
        break;
      case 'searchCriteriaChanged':
        let { searchCriteriaKey } = event;
        RA.KBSearch.applyFilter({ searchCriteria: searchCriteriaKey.key }, callback, { isbrowse: false });
        break;
      case 'attributeSetChanged':
        RA.KBSearch.applyFilter({ attributesetname: event.setName },
          callback);
        break;
      case 'attributesChanged':
        let { setName, attributes } = event;

        RA.KBSearch.applyFilter({
          attributesetname: setName,
          attributes: attributes.join(';')
        }, callback);
        break;
      case 'collectionsChanged':
        RA.KBSearch.applyFilter({ searchaliases: event.collections.join(';') },
          callback);
        break;
      case 'typesChanged':
        RA.KBSearch.applyFilter({ advkeywords: event.types.join(';') },
          callback);
        break;
      case 'categoryChanged':
        RA.KBSearch.applyFilter({ taxlevelValue: event.taxPath },
          callback);
        break;
      case 'dateChanged':
        let { startDate, endDate } = event;
        RA.KBSearch.applyFilter({
          advstartdate: startDate,
          advenddate: endDate
        }, callback);
        break;
      case 'favoriteChanged':
        RA.KBSearch.applyFilter({ favoritesOnly: event.favorite },
          callback);
        break;
      case 'languageChanged':
        RA.KBSearch.applyFilter({ language: event.language },
          callback);
        break;
      case 'resetFilters':
        RA.KBSearch.resetFilters(callback);
        break;
    }
  },
  handleRakeNonFederatedResultsEvent(event) {
    let callback = this.rakeNonFederatedSearchComplete.bind(this);
    let additionalParams = { searchCriteria: 'keyword' };

    RA.showOverlay(this.$rakeNonFederatedResultPane);
    this.scrollToTopOfResults();

    switch (event.actionType) {
      case 'pageClicked':
        RA.RakeNonFederatedSearch.nonFederatedRakeLoadPage(event.num, callback, additionalParams);
        break;
      case 'sortChanged':
        let { sortKey } = event;
        let descending = sortKey.descending == undefined ? "" : sortKey.descending;

        RA.RakeNonFederatedSearch.applyFilter({ sortBy: sortKey.key, descending: descending, sortChanged: true },
          callback, additionalParams);
        break;
      case 'searchCriteriaChanged':
        let { searchCriteriaKey } = event;
        RA.RakeNonFederatedSearch.applyFilter({ searchCriteria: searchCriteriaKey.key }, callback, { isbrowse: false });
        break;
      case 'attributeSetChanged':
        RA.RakeNonFederatedSearch.applyFilter({ attributesetname: event.setName },
          callback, additionalParams);
        break;
      case 'attributesChanged':
        let { setName, attributes } = event;

        RA.RakeNonFederatedSearch.applyFilter({
          attributesetname: setName,
          attributes: attributes.join(';')
        }, callback, additionalParams);
        break;
      case 'collectionsChanged':
        RA.RakeNonFederatedSearch.applyFilter({ searchaliases: event.collections.join(';') },
          callback, additionalParams);
        break;
      case 'categoryChanged':
        RA.RakeNonFederatedSearch.applyFilter({ taxlevelValue: event.taxPath },
          callback, additionalParams);
        break;
      case 'favoriteChanged':
        RA.RakeNonFederatedSearch.applyFilter({ favoritesOnly: event.favorite },
          callback, additionalParams);
        break;
      case 'languageChanged':
        RA.RakeNonFederatedSearch.applyFilter({ language: event.language },
          callback, additionalParams);
        break;
      case 'resetFilters':
        RA.RakeNonFederatedSearch.resetNonFederatedRakeTabFilters(callback, additionalParams);
        break;
    }
  },
  kbSearchComplete(searchResults) {
    this.showKBResults(searchResults);
    RA.hideOverlay(this.$kbResultsPane);

    if (history.pushState) {
      let qs = this.kbQueryString.buildQueryString(RA.KBSearch.query);
      history.pushState({}, "", qs + location.hash);
    }
  },
  rakeNonFederatedSearchComplete(searchResults) {
    this.showRakeNonFederatedResults(searchResults);
    RA.hideOverlay(this.$rakeNonFederatedResultPane);

    if (history.pushState) {
      let qs = this.rakeNonFederatedQueryString.buildQueryString(RA.RakeNonFederatedSearch.query);
      history.pushState({}, "", qs + location.hash);
    }
  },
  handleCommResultsEvent(event) {
    let callback = this.commSearchComplete.bind(this);
    RA.showOverlay(this.$commResultsPane);
    this.scrollToTopOfResults();

    switch (event.actionType) {
      case 'pageClicked':
        RA.CommunitySearch.loadPage(event.num, callback);
        break;
      case 'sortChanged':
        let { sortKey } = event;
        let descending = sortKey.descending == undefined ? "" : sortKey.descending;

        RA.CommunitySearch.applyFilter({ sortBy: sortKey.key, descending: descending },
          callback);
        break;
      case 'searchCriteriaChanged':
        let { searchCriteriaKey } = event;
        RA.KBSearch.applyFilter({ searchCriteria: searchCriteriaKey.key }, callback, { isbrowse: false });
        break;
      case 'answerStatusChanged':
        RA.CommunitySearch.applyFilter({ answered: event.statusCode },
          callback);
        break;
      case 'communityChanged':
        RA.CommunitySearch.applyFilter({
          communityID: event.communityID,
          topicID: ""
        }, callback);
        break;
      case 'topicChanged':
        RA.CommunitySearch.applyFilter({ topicID: event.topicID },
          callback);
        break;
      case 'tagsChanged':
        RA.CommunitySearch.applyFilter({ tags: event.tagIDs.join(";") }, callback);
        break;
      case 'dateChanged':
        let { startDate, endDate } = event;

        RA.CommunitySearch.applyFilter({
          beginLastModDate: startDate,
          endLastModDate: endDate
        }, callback);
        break;
      case 'resetFilters':
        RA.CommunitySearch.resetFilters(callback);
        break;
    }
  },
  commSearchComplete(searchResults) {
    this.showCommResults(searchResults);
    RA.hideOverlay(this.$commResultsPane);

    if (history.pushState) {
      let qs = this.commQueryString.buildQueryString(RA.CommunitySearch.query);
      history.pushState({}, "", qs + location.hash);
    }

    this.updateCommunityContext(searchResults);
  }
};